export default __webpack_public_path__ + "static/media/icon-bookmark.b1bb9d38.svg";